// Mobile Shopify Chat Fade Script
(function() {
    let chatElement;
    let isInitialized = false;
    
    // Check if we're on mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Function to wait for element to load
    function waitForElement() {
        chatElement = document.getElementById('shopify-chat');
        
        if (chatElement && !isInitialized) {
            initializeFadeBehavior();
            isInitialized = true;
            return;
        }
        
        if (!chatElement) {
            // Try to find any elements with "chat" or "shopify" in their ID/class
            const possibleElements = document.querySelectorAll('[id*="chat"], [class*="chat"], [id*="shopify"], [class*="shopify"]');
            if (possibleElements.length > 0) {
                // console.log('Found possible chat-related elements:', possibleElements);
            }
        }
        
        // Keep checking every 500ms
        if (!isInitialized) {
            setTimeout(waitForElement, 500);
        }
    }
    
    // Initialize the fade behavior
    function initializeFadeBehavior() {
        if (!chatElement) return;
        
        
        // Set initial CSS for smooth transitions
        chatElement.style.transition = 'opacity 0.3s ease-in-out';
        
        // Function to handle scroll behavior
        function handleScroll() {
            // Only run on mobile
            if (!isMobile()) {
                chatElement.style.opacity = '1';
                return;
            }
            
            // Calculate scroll position
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            
            // Distance from bottom of page
            const distanceFromBottom = documentHeight - (scrollTop + windowHeight);
            
            // Debug scroll info
            const debugInfo = {
                scrollTop: scrollTop,
                windowHeight: windowHeight,
                documentHeight: documentHeight,
                distanceFromBottom: distanceFromBottom,
                currentOpacity: chatElement.style.opacity
            };
            
            // Only log every 10th scroll event to avoid spam
            if (Math.random() < 0.1) {
                console.log('📊 Scroll debug:', debugInfo);
            }
            
            // Fade out when within 200px of the bottom
            const fadeThreshold = 200;
            
            if (distanceFromBottom <= fadeThreshold) {
                chatElement.style.opacity = '0';
            } else {
                chatElement.style.opacity = '1';
            }
        }
        
        // Throttle function for performance
        function throttle(func, limit) {
            let inThrottle;
            return function() {
                const args = arguments;
                const context = this;
                if (!inThrottle) {
                    func.apply(context, args);
                    inThrottle = true;
                    setTimeout(() => inThrottle = false, limit);
                }
            }
        }
        
        // Add event listeners
        const throttledScroll = throttle(handleScroll, 16); // ~60fps
        window.addEventListener('scroll', throttledScroll);
        window.addEventListener('resize', handleScroll);
        
        // Initial check
        handleScroll();
    }
    
    // Start checking for the element
    waitForElement();

})();

(function() {
  const cursor = document.querySelector('.custom-cursor');
  const gif = cursor.querySelector('.cursor-gif');
  const icon = cursor.querySelector('.cursor-icon');
  const text = cursor.querySelector('.cursor-text');
  const hoverElements = document.querySelectorAll('.hover-element');
  
  // Offset to center elements on cursor
  const offsetX = 60; // half of 120px
  const offsetY = 60;
  
  // Text follows cursor tightly
  const textX = gsap.quickTo(text, 'x', { duration: 0.1, ease: 'power2.out' });
  const textY = gsap.quickTo(text, 'y', { duration: 0.1, ease: 'power2.out' });
  
  // Icon trails behind text
  const iconX = gsap.quickTo(icon, 'x', { duration: 0.25, ease: 'power2.out' });
  const iconY = gsap.quickTo(icon, 'y', { duration: 0.25, ease: 'power2.out' });
  
  // GIF trails behind icon
  const gifX = gsap.quickTo(gif, 'x', { duration: 0.4, ease: 'power2.out' });
  const gifY = gsap.quickTo(gif, 'y', { duration: 0.4, ease: 'power2.out' });
  
  let isHovering = false;
  let shouldHideCursor = false;
  
  function handleMouseEnter(e) {
    isHovering = true;
    
    // Set initial positions immediately
    const x = e.clientX - offsetX;
    const y = e.clientY - offsetY;
    gsap.set([text, icon, gif], { x, y });
    
    // Only show if not hovering a hide-custom-cursor element
    if (!shouldHideCursor) {
      gsap.to(cursor, { opacity: 1, duration: 0.2 });
    }
  }
  
  function handleMouseLeave() {
    isHovering = false;
    gsap.to(cursor, { opacity: 0, duration: 0.2 });
  }
  
  function handleMouseMove(e) {
    if (!isHovering) return;
    
    const x = e.clientX - offsetX;
    const y = e.clientY - offsetY;
    
    // Check if hovering over a hide-custom-cursor element
    const elementUnderCursor = document.elementFromPoint(e.clientX, e.clientY);
    const newShouldHide = elementUnderCursor?.closest('.hide-custom-cursor') !== null;
    
    // Smoothly toggle cursor visibility if state changed
    if (newShouldHide !== shouldHideCursor) {
      shouldHideCursor = newShouldHide;
      gsap.to(cursor, { 
        opacity: shouldHideCursor ? 0 : 1, 
        duration: 0.15,
        ease: 'power2.out'
      });
    }
    
    // Each element follows the cursor at different speeds
    // Creating a trailing snake effect
    textX(x);
    textY(y);
    iconX(x);
    iconY(y);
    gifX(x);
    gifY(y);
  }
  
  // Attach events to all hover elements
  hoverElements.forEach(el => {
    el.addEventListener('mouseenter', handleMouseEnter);
    el.addEventListener('mouseleave', handleMouseLeave);
    el.addEventListener('mousemove', handleMouseMove);
  });
})();